export const advertiserRouteNames = {
  DASHBOARD: { name: 'DASHBOARD' },
  MY_CAMPAIGNS: { name: 'MY_CAMPAIGNS' },
  CAMPAIGN_DETAILS: { name: 'CAMPAIGN_DETAILS' },
  CHANGE_MEDIA: { name: 'CHANGE_MEDIA' }
};